import axios from "axios";
import { api } from "@/api";

const types = {
  SET_TRANSACTION_SUBTYPES: "SET_TRANSACTION_SUBTYPES",
  FETCH_FAILURE: "FETCH_FAILURE",
};

export const state = {
  transacitonSubtypes: [],
};

export const mutations = {
  [types.SET_TRANSACTION_SUBTYPES](state: any, data: any) {
    state.transacitonSubtypes = data;
  },
};

export const actions = {
  async fetch({ commit }: any) {
    try {
      if (state.transacitonSubtypes.length !== 0) {
        return;
      }
      const { data } = await axios.get(
        api.path("v2.admin.transactionSubtypes")
      );
      commit(types.SET_TRANSACTION_SUBTYPES, data.data);
    } catch (e) {
      commit(types.FETCH_FAILURE);
    }
  },

  async refresh({ commit }: any) {
    try {
      const { data } = await axios.get(
        api.path("v2.admin.transactionSubtypes")
      );
      commit(types.SET_TRANSACTION_SUBTYPES, data.data);
    } catch (e) {
      commit(types.FETCH_FAILURE);
    }
  },

  set({ commit }: any, payload: any) {
    commit(types.SET_TRANSACTION_SUBTYPES, payload);
  },
};

export const getters = {
  transacitonSubtypes: (state: any) => state.transacitonSubtypes,
};
